<template>
  <v-card>
    <v-card-title>{{ $t("races.title") }}</v-card-title>
    <v-card-text>
        <Exporter :headers="headers" :data="this.items" filename="races.csv" />
        <v-data-table
            :headers="headers"
            :items="this.items"
            must-sort hide-default-headers disable-pagination hide-default-footer>
            <template v-slot:item.name="{item}">
             <v-tooltip bottom v-if="item.publicDisplay">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small>public</v-icon>
                </template>
                <span>{{$t("races.publicDisplay")}}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.announcement">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small>record_voice_over</v-icon>
                </template>
                <span>{{$t("races.announcement")}}</span>
              </v-tooltip>
              <router-link :to="'races/'+item.id">{{ item.name }}</router-link>
          </template>
          <template v-slot:item.applicationType="{item}">
            {{ applicationType(item.applicationType) }}
          </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
        <v-btn to="races/new" color="success">
        {{ $t("ctrl.add") }}
        </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardTitle,
    VCardText,
    VSelect,
    VDataTable,
    VDatePicker,
  } from 'vuetify/lib'
  import fccapi from '../../fccapi'
  import Exporter from '../Exporter.vue'

  export default {
    name: 'FCCCompetitionRaces',
    data: function(){
        return {
            items: [],
            
        }
    },
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      },
        selectedCompetition: function() {
            return this.$store.getters['competitionId'];
        },
        headers: function(){
            return [
                { text: this.$t("races.name"), value: "name"},
                { text: this.$t("application.type"), value: "applicationType"},
                { text: this.$t("races.previous"), value: "previousRace.name"},
                { text: this.$t("races.maximalRuns"), value: "maximalRuns"},
            ];
        }
    },
    methods: {
        applicationType: function(i) {
            return this.$t('application.'+Array('individual', 'tandem', 'relay')[i]);
        },
        reload: function(){
            fccapi.competitionGet("races").then(d=>{
                this.items = d.data
            })
        }
    },
    mounted: function(){
        this.reload();
    },
    watch: {
        selectedCompetition() {
            console.log("changed")
            this.reload();
        }
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardTitle,
        VCardText,
        VSelect,
        VDataTable,
        VDatePicker,
        Exporter
    },    
  }
</script>